import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { ConstantService } from "../../../services/ConstantService";
import CustomTextInput from "../../../components/CustomTextInput";
import CustomSwitch from "../../../components/CustomSwitch";
import CustomDatePicker from "../../../components/CustomDatePicker";
import { ServiceService } from "../../../services/ServiceService";
import CustomNumberInput from "../../../components/CustomNumberInput";
import moment from "moment";
import { AddPriceRequest } from "../../../models/request/price/AddPriceRequest";
import { PriceService } from "../../../services/PriceService";
import { AddPriceResponse } from "../../../models/response/price/AddPriceResponse";
import { GetPriceByIdResponse } from "../../../models/response/price/GetPriceByIdResponse";

const PriceAdd = () => {
    const navigate = useNavigate();
    const pageName = "Antrepo Modülü > Anlaşmalar > Fiyat Listesi"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const [priceId, setPriceId] = useState<string | undefined>(undefined);
    const [refNo, setRefNo] = useState<string | undefined>(undefined);
    const [isOpenArea, setIsOpenArea] = useState(false);
    const [isClosedArea, setIsClosedArea] = useState(true);
    const [isHeatControllerRoom, setIsHeatControllerRoom] = useState(false);
    const [selectedHeatControlDetail, setSelectedHeatControlDetail] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [isCustomActive, setIsCustomActive] = useState(true);
    const [startDate, setStartDate] = useState<string | undefined>(moment(new Date()).format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState<string | undefined>(moment().endOf('year').format('YYYY-MM-DD'));
    const [selectedProductKind, setSelectedProductKind] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedPotType, setSelectedPotType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedService, setSelectedService] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedMultiplier1, setSelectedMultiplier1] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedMultiplier2, setSelectedMultiplier2] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [unitPrice, setUnitPrice] = useState<string | undefined>('0');
    const [selectedCurrencyType, setSelectedCurrencyType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [minPrice, setMinPrice] = useState<string | undefined>('0');

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetPriceByIdResponse = await PriceService.getPriceById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setPriceId(response.data.priceId);
                setRefNo(response.data.refNo);
                setIsOpenArea(response.data.isOpenArea);
                setIsClosedArea(response.data.isClosedArea);
                setIsHeatControllerRoom(response.data.isHeatControllerRoom);
                setIsCustomActive(response.data.isCustomActive);
                setStartDate(response.data.startDate);
                setEndDate(response.data.endDate);

                if (response.data.productKindId)
                    setSelectedProductKind({ label: response.data.productKindName, value: response.data.productKindId });

                if (response.data.potTypeId)
                    setSelectedPotType({ label: response.data.potTypeName, value: response.data.potTypeId });

                if (response.data.serviceId)
                    setSelectedService({ label: response.data.serviceName, value: response.data.serviceId });

                if (response.data.multiplier1Id)
                    setSelectedMultiplier1({ label: response.data.multiplier1Name, value: response.data.multiplier1Id });

                if (response.data.multiplier2Id)
                    setSelectedMultiplier2({ label: response.data.multiplier2Name, value: response.data.multiplier2Id });

                setUnitPrice(response.data.unitPrice?.toString());

                if (response.data.currencyTypeId)
                    setSelectedCurrencyType({ label: response.data.currencyTypeName, value: response.data.currencyTypeId });

                setMinPrice(response.data.minPrice?.toString());

                if (response.data.heatControlDetailId)
                    setSelectedHeatControlDetail({ label: response.data.heatControlDetailName, value: response.data.heatControlDetailId });
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const resetFields = () => {
        setPriceId(undefined);
        setRefNo('');
        setIsOpenArea(false);
        setIsClosedArea(true);
        setIsHeatControllerRoom(false);
        setSelectedHeatControlDetail(undefined);
        setIsCustomActive(true);
        setStartDate(moment(new Date()).format("YYYY-MM-DD"));
        setEndDate(moment().endOf('year').format('YYYY-MM-DD'));
        setSelectedProductKind(undefined);
        setSelectedPotType(undefined);
        setSelectedService(undefined);
        setSelectedMultiplier1(undefined);
        setSelectedMultiplier2(undefined);
        setUnitPrice('');
        setSelectedCurrencyType(undefined);
        setMinPrice('0');
    }

    const savePrice = async (isReset: boolean) => {
        try {
            if (Helpers.isEmpty(startDate))
                toast.error('Başlangıç Tarihi alanını doldurunuz!')
            else if (Helpers.isEmpty(endDate))
                toast.error('Bitiş Tarihi alanını doldurunuz!')
            else if (!selectedProductKind)
                toast.error('Ürün Cinsi alanını doldurunuz!')
            else if (!selectedPotType)
                toast.error('Kap Cinsi alanını doldurunuz!')
            else if (!selectedService)
                toast.error('Hizmet Kalemi alanını doldurunuz!')
            else if (!selectedMultiplier1)
                toast.error('Çarpan 1 alanını doldurunuz!')
            // else if (!selectedMultiplier2)
            //     toast.error('Çarpan 2 alanını doldurunuz!')
            else if (Helpers.isEmpty(unitPrice))
                toast.error('Birim Fiyat alanını doldurunuz!')
            else if (!selectedCurrencyType)
                toast.error('Döviz Cinsi alanını doldurunuz!')
            else if (Helpers.isEmpty(minPrice))
                toast.error('Min. Fiyat alanını doldurunuz!')
            else if (!isOpenArea && !isClosedArea && !isHeatControllerRoom)
                toast.error('Açık Alan veya Kapalı Alan veya Isı Kontrollü Oda alanlarından en az bir tanesi dolu olmalıdır!')
            else if (isHeatControllerRoom && !selectedHeatControlDetail)
                toast.error('Derece alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var o: AddPriceRequest = {
                    priceId: priceId,
                    refNo: refNo,
                    name: [
                        (isOpenArea ? 'Açık Alan' : isClosedArea ? 'Kapalı Alan' : isHeatControllerRoom ? 'Isı Kontrollü Oda' : ''),
                        selectedHeatControlDetail?.label,
                        selectedService?.label,
                        selectedProductKind?.label?.split('-')[0]?.trim(),
                        selectedPotType?.label,
                        (
                            '(' +
                            [
                                (Helpers.isEmpty(selectedMultiplier1?.label) ? '' : selectedMultiplier1?.label),
                                (Helpers.isEmpty(selectedMultiplier2?.label) ? '' : selectedMultiplier2?.label),
                                (Helpers.isEmpty(unitPrice) ? '' : unitPrice?.replaceAll(',', '.'))
                            ].filter(x => !Helpers.isEmpty(x)).join(' * ')
                            + ')'
                        ).replace('()', '')
                    ].filter(x => x && !Helpers.isEmpty(x)).join(' - '),
                    isOpenArea: isOpenArea,
                    isClosedArea: isClosedArea,
                    isHeatControllerRoom: isHeatControllerRoom,
                    isCustomActive: isCustomActive,
                    startDate: startDate,
                    productKindId: selectedProductKind?.value,
                    potTypeId: selectedPotType?.value,
                    heatControlDetailId: selectedHeatControlDetail?.value,
                    serviceId: selectedService?.value,
                    multiplier1Id: selectedMultiplier1?.value,
                    multiplier2Id: selectedMultiplier2?.value,
                    unitPrice: unitPrice,
                    currencyTypeId: selectedCurrencyType.value,
                    minPrice: minPrice,
                    endDate: endDate
                }

                var response: AddPriceResponse = await PriceService.addPrice(o);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));

                if (isReset)
                    resetFields();
                else
                    navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <div>
                        <KTCard className="ebbe-card">
                            <KTCardBody>
                                <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                                <div className='row'>
                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Ref No</label>
                                            <CustomTextInput value={refNo} isDisabled />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Ad</label>
                                            <CustomTextInput isDisabled value={
                                                [
                                                    (isOpenArea ? 'Açık Alan' : isClosedArea ? 'Kapalı Alan' : isHeatControllerRoom ? 'Isı Kontrollü Oda' : ''),
                                                    selectedHeatControlDetail?.label,
                                                    selectedService?.label,
                                                    selectedProductKind?.label?.split('-')[0]?.trim(),
                                                    selectedPotType?.label,
                                                    (
                                                        '(' +
                                                        [
                                                            (Helpers.isEmpty(selectedMultiplier1?.label) ? '' : selectedMultiplier1?.label),
                                                            (Helpers.isEmpty(selectedMultiplier2?.label) ? '' : selectedMultiplier2?.label),
                                                            (Helpers.isEmpty(unitPrice) ? '' : unitPrice?.replaceAll(',', '.'))
                                                        ].filter(x => !Helpers.isEmpty(x)).join(' * ')
                                                        + ')'
                                                    ).replace('()', '')
                                                ].filter(x => x && !Helpers.isEmpty(x)).join(' - ')} />
                                        </div>

                                        <div className="row mt-5">
                                            <div className="col-md-6">
                                                <label htmlFor="exampleFormControlInput1" className="form-label required">Açık Alan</label>
                                                <CustomSwitch isActive={isOpenArea} setIsActive={() => {
                                                    setSelectedHeatControlDetail(undefined);
                                                    setIsOpenArea(!isOpenArea);
                                                    setIsClosedArea(false);
                                                    setIsHeatControllerRoom(false);
                                                }} />
                                            </div>

                                            <div className="col-md-6">
                                                <label htmlFor="exampleFormControlInput1" className="form-label required">Kapalı Alan</label>
                                                <CustomSwitch isActive={isClosedArea} setIsActive={() => {
                                                    setSelectedHeatControlDetail(undefined);
                                                    setIsOpenArea(false);
                                                    setIsClosedArea(!isClosedArea);
                                                    setIsHeatControllerRoom(false);
                                                }} />
                                            </div>
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Isı Kontrollü Oda</label>
                                            <CustomSwitch isActive={isHeatControllerRoom} setIsActive={() => {
                                                setSelectedHeatControlDetail(undefined);
                                                setIsOpenArea(false);
                                                setIsClosedArea(false);
                                                setIsHeatControllerRoom(!isHeatControllerRoom);
                                            }} />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Aktif</label>
                                            <CustomSwitch isActive={isCustomActive} setIsActive={setIsCustomActive} />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Başlangıç Tarihi</label>
                                            <CustomDatePicker value={startDate} setValue={setStartDate} />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Bitiş Tarihi</label>
                                            <CustomDatePicker value={endDate} setValue={setEndDate} />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Ürün Cinsi</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedProductKind}
                                                onChange={setSelectedProductKind}
                                                onMenuOpen={() => ConstantService.getConstantList('PRODUCT_KIND', undefined, undefined)}
                                                labelName='value'
                                                valueName='constantId'
                                            />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Kap Cinsi</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedPotType}
                                                onChange={setSelectedPotType}
                                                onMenuOpen={() => ConstantService.getConstantList('POT_TYPE', undefined, undefined)}
                                                labelName='value'
                                                valueName='constantId'
                                            />
                                        </div>

                                        {
                                            isHeatControllerRoom && (
                                                <div className="mt-5">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label required">Derece</label>

                                                    <CustomSingleSelect
                                                        selectedValue={selectedHeatControlDetail}
                                                        onChange={setSelectedHeatControlDetail}
                                                        onMenuOpen={() => ConstantService.getConstantList('HEAT_CONTROL_DETAIL')}
                                                        labelName='value'
                                                        valueName='constantId'
                                                    />
                                                </div>
                                            )
                                        }
                                    </div>

                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Hizmet Kalemi</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedService}
                                                onChange={setSelectedService}
                                                onMenuOpen={() => ServiceService.getServiceList(undefined, undefined)}
                                                labelName='name'
                                                valueName='serviceId'
                                            />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Çarpan 1</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedMultiplier1}
                                                onChange={setSelectedMultiplier1}
                                                onMenuOpen={() => ConstantService.getConstantList('MULTIPLIER_TYPE')}
                                                labelName='value'
                                                valueName='constantId'
                                            />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput2" className="form-label">Çarpan 2</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedMultiplier2}
                                                onChange={setSelectedMultiplier2}
                                                onMenuOpen={() => ConstantService.getConstantList('MULTIPLIER_TYPE')}
                                                labelName='value'
                                                valueName='constantId'
                                            />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Birim Fiyat</label>
                                            <CustomNumberInput value={unitPrice} setValue={setUnitPrice} />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Döviz Cinsi</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedCurrencyType}
                                                onChange={setSelectedCurrencyType}
                                                onMenuOpen={() => ConstantService.getConstantList('CURRENCY')}
                                                labelName='additionalValue1'
                                                valueName='constantId'
                                            />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Min. Fiyat</label>
                                            <CustomNumberInput value={minPrice} setValue={setMinPrice} />
                                        </div>
                                    </div>
                                </div>
                            </KTCardBody>
                        </KTCard>
                    </div>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">
                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box mr="15px">
                                    <button style={{ background: 'orange', color: 'white' }} className="btn btn-sm" onClick={() => savePrice(true)}>Kaydet & Yeni Kayıt</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={() => savePrice(false)}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default PriceAdd;